export default __webpack_public_path__ + "static/media/user-check.5b1a9ac5.svg";